var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-role=\"modal\" class=\"modal fade catalog-modal catalog-dm\" tabindex=\"-1\" role=\"dialog\"\r\n     aria-labelledby=\"analysisCatalog\">\r\n    <div class=\"modal-dialog modal-lg\">\r\n        <div class=\"modal-content\">\r\n\r\n            <div id=\"catalog-container\"></div>\r\n\r\n        </div>\r\n    </div>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/search.hbs
// module id = 43
// module chunks = 0